module.exports = __webpack_public_path__ + "assets/img/f23c6b07c8e0b91ebc0c23b252339fc3.svg";